import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Moving 13 years of Wordpress blog to Gatsby Markdown",
  "description": "",
  "published": "2019-09-23T00:00:00.000Z",
  "redirect_from": ["/blog/moving-13-years-of-wordpress-blog-to-gatsby-markdown/swizec/9204"],
  "categories": "Technical",
  "hero": "./img/techletter.app-screenshot-1569254657692.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Did you know most websites go offline within 2 years of publishing? Don't let your writing join the graveyard.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=kQCAq7jxgiI"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M384%203c0%203%201%204%202%204%202%200%202%204%202%2063v64h-23l-22%201-1%205c0%2010-2%209%2024%209h23l-23%201-23%201-1%209%201%2010v3l-1%208c0%205%201%205%203%206s2%201-1%201-4%200-3%201v3l-1-2c-1-3-3-2-5%201-1%202-1%202%203%202s7%203%205%206l-1%205c0%203-1%203-4%203s-4%200-4%202c0%203-1%203-12%203l-9%201-2%201-2-1h-21l-5-1-5%201-4%201-4-1-1-1h-8c0-2-3-1-3%201-1%201-4%202-4%200l-3-1h-9c-1%202-3%203-3%201h-13c-2%203-2-2-3-32v-31h-59l-58%201-1%202-1%203-52-1H0v6c0%204%200%206%203%208%202%203%202%203%202%2016%200%2017-1%2022-3%2021-3%200-3%205%200%206v1c-2%200-2%201-2%206v6h400V2h-6l-6-1-2-1c-2%200-2%201-2%203M11%207c0%202%200%203-5%203-4%200-5%200-5%202s1%202%206%202c4%200%206%200%205-1v-1c1-1%201%200%202%201h2c0%203%204%201%204-2%201-3%201-3%204-2%202%200%203%200%204-2%201-1%201-1%201%201h1c2-2%200-3-10-3-9%200-9%200-9%202m179%2099v12c1%202%2014%203%2017%201%203-1%203-1%203-7v-6l-10-1-10%201M65%20166c-6%200-8%201-5%202h-1c-2%200-2%200-1%201s1%201-1%202-2%201%201%201c2%200%203%200%201%201-3%200-3%202%200%202l2%201h18l-2%201-6%202h-2c-4%200-4%200-1%201%202%201%202%201%200%202-2%200-3%202-1%204%201%201%2034-5%2037-7l1-7c0-6-1-7-6-6H65m-18%2019c-3%202-6%208-6%2010h3c4-1%207%200%207%202s2%202%204-1c2-2%203-2%205-2%203%201%203-3%200-7-2-4-9-5-13-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8d676fdb75e15a62d18be91295adea6a/ca0a1/techletter.app-screenshot-1569254657692.webp 223w", "/static/8d676fdb75e15a62d18be91295adea6a/75680/techletter.app-screenshot-1569254657692.webp 445w", "/static/8d676fdb75e15a62d18be91295adea6a/0ba47/techletter.app-screenshot-1569254657692.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8d676fdb75e15a62d18be91295adea6a/e92b6/techletter.app-screenshot-1569254657692.png 223w", "/static/8d676fdb75e15a62d18be91295adea6a/e66bf/techletter.app-screenshot-1569254657692.png 445w", "/static/8d676fdb75e15a62d18be91295adea6a/6af66/techletter.app-screenshot-1569254657692.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/8d676fdb75e15a62d18be91295adea6a/6af66/techletter.app-screenshot-1569254657692.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`More and more people are creating blogs with Gatsby and that's exciting as heck! I miss the internet days when everyone had a place to call their own.`}</p>
    <p>{`It's pretty easy, too.`}</p>
    <p>{`You initiate a repo, follow a quick tutorial, write your first article, press build, and voila: A beautiful new place to publish your ideas.`}</p>
    <p>{`And you get some amazing benefits we didn't get when I built my first site on Geocities.`}</p>
    <p>{`Great lighthouse scores, fast load times, easy build&publish process with Zeit or Netlify, and image optimization unlike anything I've ever seen. Plop a 40MB photo from a DSLR into your blog and Gatsby plugins convert it to a tiny fast loading 900Kb version.`}</p>
    <p>{`Done that before, didn't even notice. On Wordpress it breaks your site. Tried that too 😇`}</p>
    <p>{`But what if you already have a blog? That's where it gets tricky.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1163833379395006464"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "99.55156950672647%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'398\\'%20viewBox=\\'0%200%20400%20398\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-5%203-7%208-7%2014l2%206%201%202c0%201%206%205%2010%206%203%200%205%200%208-2%206-2%206-4%202-4-3%200-4-3-1-5l3-1%203-2c2-2%202-2%201-6-3-9-14-13-22-8m-5%20100l-1%206v6h3c7%200%2011-6%206-11-2-2-7-3-8-1m234%2066v6h3c5%200%207-2%205-5v-4c0-3-1-4-5-4-3%200-3%200-3%207m-133%2022l-2%203c-1%202-1%202-1%200%200-4-9-3-10%201%200%203%200%203%207%203%205%200%206%200%206-2%201-2%201-2%201%200l1%202%201-2%201-2v2c0%202%202%203%202%200l1-4c0-2-3-2-7-1M73%20339c-3%202-3%209%200%2010h3c5%201%208%200%208-4%200-6-7-10-11-6m18%200c-4%203-4%208-1%2011s8%203%2011-1c6-7-3-16-10-10\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3c6217016863f1d66c9c48e387481c53/ca0a1/techletter.app-screenshot-1569254610612.webp 223w", "/static/3c6217016863f1d66c9c48e387481c53/75680/techletter.app-screenshot-1569254610612.webp 445w", "/static/3c6217016863f1d66c9c48e387481c53/0ba47/techletter.app-screenshot-1569254610612.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3c6217016863f1d66c9c48e387481c53/e92b6/techletter.app-screenshot-1569254610612.png 223w", "/static/3c6217016863f1d66c9c48e387481c53/e66bf/techletter.app-screenshot-1569254610612.png 445w", "/static/3c6217016863f1d66c9c48e387481c53/6af66/techletter.app-screenshot-1569254610612.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3c6217016863f1d66c9c48e387481c53/6af66/techletter.app-screenshot-1569254610612.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "how-to-move-an-existing-wordpress-blog-to-gatsby"
    }}>{`How to move an existing Wordpress blog to Gatsby`}</h2>
    <p>{`Creating the blog itself is easy:`}</p>
    <ol>
      <li parentName="ol">{`Setup repo`}</li>
      <li parentName="ol">{`Follow `}<a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/tutorial/"
        }}>{`the gatsby tutorial`}</a></li>
      <li parentName="ol">{`Add a bunch of plugins that sound useful`}</li>
    </ol>
    <p>{`Now, your old stuff may not be great but you should keep it anyway. For the memories, for not breaking old links, for being a good member of the internet.`}</p>
    <p>{`Did you know most websites go offline within 2 years of publishing? Don't let your writing join the graveyard.`}</p>
    <p>{`There's 2 parts to this and both are hard:`}</p>
    <ol>
      <li parentName="ol">{`Convert your Wordpress history to a format Gatsby understands`}</li>
      <li parentName="ol">{`Keep the old links working`}</li>
    </ol>
    <p>{`I haven't solved #2 yet. I imagine there's going to be a redirect page on Gatsby that takes a URL from the old format and pushes you to the correct article.`}</p>
    <p>{`No. 1 proved harder than I thought.`}</p>
    <h2 {...{
      "id": "a-script-that-converts-wordpress-to-gatsby"
    }}>{`A script that converts Wordpress to Gatsby`}</h2>
    <p>{`Gatsby has a plugin to source data directly from Wordpress's API. This is great, if you want to continue using Wordpress as your CMS and use Gatsby as the frontend.`}</p>
    <p>{`I prefer writing in Markdown.`}</p>
    <p>{`Your other option is downloading the `}<inlineCode parentName="p">{`wordpress.xml`}</inlineCode>{` datadump and converting it to Gatsby. Get all your content, your blogs, even the comments in one big file ... then what?`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/2f30dea8076b80d98696008722e6712b/2a333/rkFOnrE.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48.4304932735426%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'193\\'%20viewBox=\\'0%200%20400%20193\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2019c0%2018%200%2018%202%2016l2-1-1%203-3%202v27c0%2024%200%2026%202%2025l2-4c1-2%203-3%203%200l1%201h1c0%201-7%206-8%205l-1%2050v50h81v-50c0-49%200-50-2-52l-2-1%202-2c2-3%202-4%202-45V0H0v19m93%20137v8l1%207h80v-15l-40-1-41%201m7%205c-3%202%201%206%204%204h1l1%201v-2h1l1%201h4l1-1c0-1%201-1%201%201l1%202v-2c0-2%200-2%201-1l2%201h2l1%201v-2h1c2%202%205%203%205%201h1c0%203%203%201%203-2s0-3-2-2c-1%202-2%202-3%201s-1-1-2%201c-1%201-1%201-1-1h-3c-1%201-1%201-1-1h-1c0%202-1%202-1%201h-13c-1-2-3-3-4-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/2f30dea8076b80d98696008722e6712b/ca0a1/rkFOnrE.webp 223w", "/static/2f30dea8076b80d98696008722e6712b/75680/rkFOnrE.webp 445w", "/static/2f30dea8076b80d98696008722e6712b/8d1ba/rkFOnrE.webp 890w", "/static/2f30dea8076b80d98696008722e6712b/3838e/rkFOnrE.webp 1335w", "/static/2f30dea8076b80d98696008722e6712b/17fe2/rkFOnrE.webp 1484w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/2f30dea8076b80d98696008722e6712b/e92b6/rkFOnrE.png 223w", "/static/2f30dea8076b80d98696008722e6712b/e66bf/rkFOnrE.png 445w", "/static/2f30dea8076b80d98696008722e6712b/4ef49/rkFOnrE.png 890w", "/static/2f30dea8076b80d98696008722e6712b/4e814/rkFOnrE.png 1335w", "/static/2f30dea8076b80d98696008722e6712b/2a333/rkFOnrE.png 1484w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/2f30dea8076b80d98696008722e6712b/4ef49/rkFOnrE.png",
              "alt": "rkFOnrE",
              "title": "rkFOnrE",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Then you 👇`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://github.com/Swizec/wordpress-to-markdown"
        }}>{`clone this wordpress-to-markdown repo`}</a></li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`yarn install`}</inlineCode>{` or `}<inlineCode parentName="li">{`npm install`}</inlineCode>{` as preferred`}</li>
      <li parentName="ol">{`Name your file `}<inlineCode parentName="li">{`export.xml`}</inlineCode>{` and place it in root`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://github.com/Swizec/wordpress-to-markdown/blob/master/convert.js#L181"
        }}>{`Edit line 181`}</a>{` to change the author`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`node convert.js`}</inlineCode></li>
      <li parentName="ol">{`Wait`}</li>
    </ol>
    <p>{`Yes it's a little hacky right now. Might productize later :)`}</p>
    <p><inlineCode parentName="p">{`convert.js`}</inlineCode>{` started life as `}<a parentName="p" {...{
        "href": "https://github.com/ytechie"
      }}>{`ytechie`}</a>{`'s hack some 6 years ago. A couple forks later I found a version that mostly works in 2019.`}</p>
    <p>{`Making it work for Gatsby took some tinkering.`}</p>
    <p>{`The generated Markdown wasn't valid `}<a parentName="p" {...{
        "href": "https://github.com/mdx-js/mdx"
      }}>{`MDX`}</a>{`, which I prefer for blogs since it lets you run JavaScript, downloading images was wonky, and I needed more self-contained posts with better headers. Gatsby likes it when each article comes in its own folder with its own images.`}</p>
    <p>{`Using a folder-per-article schema also makes it filename collisions less likely. ✌️`}</p>
    <h3 {...{
      "id": "parse-xml-posts-into-gatsby"
    }}>{`Parse XML posts into Gatsby`}</h3>
    <p>{`The core of `}<inlineCode parentName="p">{`convert.js`}</inlineCode>{` is a method that parses XML, iterates through posts, generates markdown, and downloads all images.`}</p>
    <p>{`Using `}<a parentName="p" {...{
        "href": "https://github.com/Leonidas-from-XIV/node-xml2js"
      }}>{`xml2js`}</a>{` to parse XML, `}<a parentName="p" {...{
        "href": "https://github.com/rehypejs/rehype"
      }}>{`rehype`}</a>{` to parse HTML content, `}<a parentName="p" {...{
        "href": "https://github.com/remarkjs/remark"
      }}>{`remark`}</a>{` to generate Markdown, and good old `}<a parentName="p" {...{
        "href": "https://github.com/bitinn/node-fetch"
      }}>{`node-fetch`}</a>{` to download images.`}</p>
    <p>{`You can see the `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/wordpress-to-markdown"
      }}>{`full code on GitHub`}</a>{` altho it's not the prettiest.`}</p>
    <p>{`Here's the fun part that takes HTML and spits out Markdown 😛`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20markdown%20%3D%20await%20new%20Promise((resolve%2C%20reject)%20%3D%3E%20%7B%0A%20%20%20%20unified()%0A%20%20%20%20%20%20%20%20.use(parseHTML%2C%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20emitParseErrors%3A%20true%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20duplicateAttribute%3A%20false%0A%20%20%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20%20%20.use(rehype2remark)%0A%20%20%20%20%20%20%20%20.use(stringify)%0A%20%20%20%20%20%20%20%20.process(postData%2C%20(err%2C%20markdown)%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20if%20(err)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20reject(err)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20resolve(markdown.contents)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%7D)%3B%0A%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "558px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "82.0627802690583%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'328\\'%20viewBox=\\'0%200%20400%20328\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2037a6981%206981%200%20001%20256c1%201%2029%202%20175%202s174-1%20175-2c2-1%202-11%202-128l-1-128c-1-3-351-3-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/be7eb5c5699e95ec91d57bd0f84274ab/ca0a1/techletter.app-screenshot-1569254611375.webp 223w", "/static/be7eb5c5699e95ec91d57bd0f84274ab/75680/techletter.app-screenshot-1569254611375.webp 445w", "/static/be7eb5c5699e95ec91d57bd0f84274ab/1c397/techletter.app-screenshot-1569254611375.webp 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/be7eb5c5699e95ec91d57bd0f84274ab/e92b6/techletter.app-screenshot-1569254611375.png 223w", "/static/be7eb5c5699e95ec91d57bd0f84274ab/e66bf/techletter.app-screenshot-1569254611375.png 445w", "/static/be7eb5c5699e95ec91d57bd0f84274ab/42a8d/techletter.app-screenshot-1569254611375.png 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/be7eb5c5699e95ec91d57bd0f84274ab/42a8d/techletter.app-screenshot-1569254611375.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I forked from a version with `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/wordpress-to-markdown/commit/5214b4e0f8836dbb1bf40d872ee2993f66fab7a0"
      }}>{`a complex homegrown Markdown generator`}</a>{` and many bugs. Mixing rehype, remark, unified, and plugins makes the process more reliable and easier to maintain.`}</p>
    <ol>
      <li parentName="ol">{`Parse HTML to an AST`}</li>
      <li parentName="ol">{`Convert to Markdown AST`}</li>
      <li parentName="ol">{`Stringify`}</li>
      <li parentName="ol">{`Output`}</li>
    </ol>
    <p>{`👌`}</p>
    <p>{`My surrounding code adds some headers and other meta data. Makes it easier to plop straight into Gatsby.`}</p>
    <h3 {...{
      "id": "download-all-the-images"
    }}>{`Download all the images`}</h3>
    <p>{`Most images on my old posts are dead. 404, 500, 301, you name the error, it's in there somewhere.`}</p>
    <p>{`The only way to avoid that fate in the future is to keep local copies of images that you host yourself. Gatsby supports that really well with MDX – put images next to your words and use relative paths.`}</p>
    <p>{`But you need to download them first.`}</p>
    <p>{`I created this `}<inlineCode parentName="p">{`processImage`}</inlineCode>{` method and tried a few different ways to download images one by one. The original crashed my computer. Too much parallelism.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=async%20function%20processImage(%7B%20url%2C%20postData%2C%20images%2C%20directory%20%7D)%20%7B%0A%20%20%20%20var%20urlParts%20%3D%20url.split(%22%2F%22)%3B%0A%20%20%20%20var%20imageName%20%3D%20urlParts%5BurlParts.length%20-%201%5D%3B%0A%0A%20%20%20%20var%20filePath%20%3D%20%60out%2F%24%7Bdirectory%7D%2Fimg%2F%24%7BimageName%7D%60%3B%0A%0A%20%20%20%20try%20%7B%0A%20%20%20%20%20%20%20%20await%20downloadFile(url%2C%20filePath)%3B%0A%20%20%20%20%20%20%20%20%2F%2FMake%20the%20image%20name%20local%20relative%20in%20the%20markdown%0A%20%20%20%20%20%20%20%20postData%20%3D%20postData.replace(url%2C%20%60.%2Fimg%2F%24%7BimageName%7D%60)%3B%0A%20%20%20%20%20%20%20%20images%20%3D%20%5B...images%2C%20%60.%2Fimg%2F%24%7BimageName%7D%60%5D%3B%0A%20%20%20%20%7D%20catch%20(e)%20%7B%0A%20%20%20%20%20%20%20%20console.log(%60Keeping%20ref%20to%20%24%7Burl%7D%60)%3B%0A%20%20%20%20%20%20%20%20console.log(e)%3B%0A%20%20%20%20%7D%0A%0A%20%20%20%20return%20%5BpostData%2C%20images%5D%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "638px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "77.13004484304933%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'309\\'%20viewBox=\\'0%200%20400%20309\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2031c-2%202-2%20246%200%20248s356%202%20358%200%202-246%200-248-356-2-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/308c46ef8cb49702ff30fb1b55ebd4dd/ca0a1/techletter.app-screenshot-1569254611336.webp 223w", "/static/308c46ef8cb49702ff30fb1b55ebd4dd/75680/techletter.app-screenshot-1569254611336.webp 445w", "/static/308c46ef8cb49702ff30fb1b55ebd4dd/a2d8a/techletter.app-screenshot-1569254611336.webp 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/308c46ef8cb49702ff30fb1b55ebd4dd/e92b6/techletter.app-screenshot-1569254611336.png 223w", "/static/308c46ef8cb49702ff30fb1b55ebd4dd/e66bf/techletter.app-screenshot-1569254611336.png 445w", "/static/308c46ef8cb49702ff30fb1b55ebd4dd/41be6/techletter.app-screenshot-1569254611336.png 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/308c46ef8cb49702ff30fb1b55ebd4dd/41be6/techletter.app-screenshot-1569254611336.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Ignore the ancient `}<inlineCode parentName="p">{`var`}</inlineCode>{` syntax, I didn't want to rewrite everything 😇`}</p>
    <p>{`We take an image URL, split it into parts, create a new `}<inlineCode parentName="p">{`filePath`}</inlineCode>{`, run the `}<inlineCode parentName="p">{`downloadFile`}</inlineCode>{` method, replace the original URL in our post with the new relative path.`}</p>
    <p>{`Updating the `}<inlineCode parentName="p">{`images`}</inlineCode>{` array is important so we can collect candidates for our hero image. The part that goes into social thumbnails and on the homepage.`}</p>
    <p>{`Tried a bunch of ways to download files, this is the one that worked best in the end.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=async%20function%20downloadFile(url%2C%20path)%20%7B%0A%20%20%20%20if%20(%0A%20%20%20%20%20%20%20%20url.indexOf(%22.jpg%22)%20%3E%3D%200%20%7C%7C%0A%20%20%20%20%20%20%20%20url.indexOf(%22.jpeg%22)%20%3E%3D%200%20%7C%7C%0A%20%20%20%20%20%20%20%20url.indexOf(%22.png%22)%20%3E%3D%200%20%7C%7C%0A%20%20%20%20%20%20%20%20url.indexOf(%22.gif%22)%20%3E%3D%200%20%7C%7C%0A%20%20%20%20%20%20%20%20url.indexOf(%22.svg%22)%20%3E%3D%200%0A%20%20%20%20)%20%7B%0A%20%20%20%20%20%20%20%20const%20response%20%3D%20await%20fetch(url)%3B%0A%20%20%20%20%20%20%20%20if%20(response.status%20%3E%3D%20400)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20throw%20new%20Error(%22Bad%20response%20from%20server%22)%3B%0A%20%20%20%20%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20const%20type%20%3D%20response.headers.get(%22Content-Type%22)%3B%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20if%20(type.includes(%22image%22)%20%7C%7C%20type.includes(%22octet-stream%22))%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20const%20buffer%20%3D%20await%20response.arrayBuffer()%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20fs.writeFileSync(path%2C%20new%20Buffer(buffer))%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20throw%20new%20Error(%22Not%20an%20image%22%2C%20url)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20%20%20console.log(%22passing%202%22)%3B%0A%20%20%20%20%20%20%20%20console.log(%22passing%20on%3A%20%22%20%2B%20url%20%2B%20%22%20%22%20%2B%20url.indexOf(%22https%3A%22))%3B%0A%20%20%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "694px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "91.92825112107623%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'367\\'%20viewBox=\\'0%200%20400%20367\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2030c-2%203-1%20308%200%20309%202%202%20360%202%20362%200%201-1%202-306%200-309-1-3-361-3-362%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7165d9a6ce433aa155a2f51645593ec9/ca0a1/techletter.app-screenshot-1569254611427.webp 223w", "/static/7165d9a6ce433aa155a2f51645593ec9/75680/techletter.app-screenshot-1569254611427.webp 445w", "/static/7165d9a6ce433aa155a2f51645593ec9/181fb/techletter.app-screenshot-1569254611427.webp 694w"],
                "sizes": "(max-width: 694px) 100vw, 694px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7165d9a6ce433aa155a2f51645593ec9/e92b6/techletter.app-screenshot-1569254611427.png 223w", "/static/7165d9a6ce433aa155a2f51645593ec9/e66bf/techletter.app-screenshot-1569254611427.png 445w", "/static/7165d9a6ce433aa155a2f51645593ec9/31198/techletter.app-screenshot-1569254611427.png 694w"],
                "sizes": "(max-width: 694px) 100vw, 694px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7165d9a6ce433aa155a2f51645593ec9/31198/techletter.app-screenshot-1569254611427.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Check the URL is an image, use `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{`, make sure the response is an image (some server errors return a success with a bunch of HTML, that was fun to learn), and write the file.`}</p>
    <p>{`You'd think this was the easiest part, but it isn't. Most libraries you find are meant to work with APIs, not file downloads. Handling all sorts of errors gets tricky, and when you have thousands of files to download you gotta be really careful with your async code.`}</p>
    <p>{`First version downloaded everything in parallel. Crashed my computer.`}</p>
    <p>{`Now it goes one-by-one which is slower, but at least it finishes.`}</p>
    <h2 {...{
      "id": "the-result"
    }}>{`The result`}</h2>
    <p>{`An error.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/42c4c576a9bee10ffebff74fe1806f9f/541fe/CI4a2eC.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.98206278026906%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'192\\'%20viewBox=\\'0%200%20400%20192\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2010v9h121a9569%209569%200%200013-2H3l-1-6%201-7%20128-1a4011%204011%200%2000124-2L128%200H0v10m19-1l1%203c3%201%2014%200%2015-1h1c0%201%204%202%205%201h1l2%201c2%200%203-1%203-3s-2-3-2%200h-1c0-2-4-2-6-1h-2c-2-2-4-2-4%200h-1l-6-1h-5c-1-1-1%200-1%201m37%2035v4h4c3%200%204%200%204-2l1-2c1-1%201%200%201%201%200%204%202%204%202%201v-2l1%202c1%202%203%204%204%202h3l1-2%201-3v-1l-2%202-1-1h-6c0-2-6-1-7%202%200%202-5%203-5%201l2-1c3%200%203-2%200-2-2-1-2-1%200-1%204%200%204-2%200-2-3%200-3%200-3%204m30-3c-3%203%201%209%204%207h3c2%201%207%200%207-2l1-2%201%202%202%202%202-2%201-2%201%202%201%202h5l3-1c1%201%201%200%201-2%200-3-2-6-2-3%200%202%200%202-2%201h-5l-5-1c-5%200-5%200-5%203v3l-1-3c-1-3-4-4-5-1%200%201-1%202-2%201l-1%201h-3c-1-3%201-5%203-4%201%201%203%201%202-1h-6m-13%2065c0%202%201%202%204%202%2010%201%2021%200%2021-1h1l3%201c2%200%203%200%203-2-1-3-32-3-32%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/42c4c576a9bee10ffebff74fe1806f9f/ca0a1/CI4a2eC.webp 223w", "/static/42c4c576a9bee10ffebff74fe1806f9f/75680/CI4a2eC.webp 445w", "/static/42c4c576a9bee10ffebff74fe1806f9f/8d1ba/CI4a2eC.webp 890w", "/static/42c4c576a9bee10ffebff74fe1806f9f/3838e/CI4a2eC.webp 1335w", "/static/42c4c576a9bee10ffebff74fe1806f9f/50272/CI4a2eC.webp 1654w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/42c4c576a9bee10ffebff74fe1806f9f/e92b6/CI4a2eC.png 223w", "/static/42c4c576a9bee10ffebff74fe1806f9f/e66bf/CI4a2eC.png 445w", "/static/42c4c576a9bee10ffebff74fe1806f9f/4ef49/CI4a2eC.png 890w", "/static/42c4c576a9bee10ffebff74fe1806f9f/4e814/CI4a2eC.png 1335w", "/static/42c4c576a9bee10ffebff74fe1806f9f/541fe/CI4a2eC.png 1654w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/42c4c576a9bee10ffebff74fe1806f9f/4ef49/CI4a2eC.png",
              "alt": "CI4a2eC",
              "title": "CI4a2eC",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`I told you this was hard.`}</p>
    <p>{`The way I setup my new Gatsby blog, it expects every article to have a hero image. Looks like some either have no images, or no working images.`}</p>
    <p>{`That's next on my list to fix. What do we do with missing images? Do I create a 404 graphic? Do I remove them from the post? What about the hero image? 🤔`}</p>
    <p>{`Until then this will continue to be the main comment I get`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/megatomche/status/1172063550401130496"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "130.94170403587444%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'524\\'%20viewBox=\\'0%200%20400%20524\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M35%209h-2c-2%200-3%201-5%203-5%206-5%2014%200%2020%203%204%204%204%204%201%200-4%202-8%203-8%202%200%206%2010%205%2011h3c2%200%202-1%201-2-2-1-2-8-1-9%202%200%204%202%205%205l1%203%202-2%203-6c0-3-1-11-3-11l-1-2c-1-4-15-7-15-3m201%2060l-1%206v6h9v-5l-1-7h-7m-33%2055l-1%207c0%206%200%207%202%207%201%200%202-1%202-4%201-5%203-5%203%200%200%203%200%204%202%204s2-1%202-4c0-5-2-8-5-7-2%201-2%200-2-2s-2-3-3-1m80%206c0%207%200%208%202%208l2-1c0-5%200-7%202-7l1%204c0%203%200%204%202%204s3-4%201-9c-1-2-2-2-4-2-3%201-3%200-3-1l-1-3c-2%200-2%201-2%207m-199-2v8c0%206%200%207%202%207%201%200%202-1%202-3s0-2%202-2c3%202%206-5%204-9-1-2-8-3-10-1m136%201c-1%203%201%2013%202%2014%202%200%202-1%202-3s0-2%202-2c3%202%206-5%204-9-1-2-9-2-10%200m97%201c1%209%205%2011%207%205v-3l1%203c1%204%204%204%206-1%202-7%200-10-2-4l-2%203v-3c-1-4-4-4-5%200l-1%203-1-3c-2-4-4-4-3%200M28%20152c-2%200-3%203-1%203s1%209-1%2010c-4%201-2%203%204%203%204%200%205%200%205-2l-1-1-1-7c0-7%200-8-5-6m10%200c-2%200-3%202%200%203%201%200%202%208%200%2010-3%201-1%203%204%203%204%200%205-1%203-2s-1-10%201-11c3-3-1-4-8-3m47%201l-2%201-3%204-2%202h-2v1c2%200%202%200%201%205-3%204-1%205%208%201%206-3%207-4%207-5-1-2%201-3%201-1h1l-2-2c-2%200-6-5-5-7l-2%201m44%2024c-3%203-3%2028%200%2032l1%202h184l1-2c3-4%203-29%200-32-2-2-3-2-93-2s-91%200-93%202m-61%2054v16h308v-33H68v17m190-9v17l8%201c8%200%209-1%209-9l-1-9h-16m90%202c-3%203-3%203-3%209v6h6c8%200%2013-4%2012-10-2-7-10-11-15-5m-213%201c-2%202-3%203-7%200-2-1-2-1-2%202l2%206c1%202%201%202-1%203-2%200%200%202%204%202s9-3%2010-9c2-5%202-5-2-6-2%200-3%200-4%202m214%200c-2%201-2%203-2%2010%201%203%209%203%2012%200%206-6-3-16-10-10m-48%200l-1%206%201%206h18v-12l-8-1-10%201M24%20413v46l2%203%203%202h58c61%200%2061%200%2060-4-1-2%204-11%206-12l10-1c11%200%2011%200%2011%202l1%201c2%200%209%209%209%2011-1%202%200%202%202%202s2%200%202-2c-1-1%200-3%202-6%204-7%204-14-2-20-3-4-3-4-4-12v-9c1-1-1-1-3-1-3%200-4%200-3%201%203%200%203%200%205%2011%200%205%200%206-5%2012l-4%207h-24v2l-1%203-1-3-1-5-2-7-2-12-1-8h3l2-1H24m236%200h-5l1%205%202%2014v9h-6l-10%201c-5%200-6%203%200%203%202%200%203%201%203%202h-7c-3-1-4-1-4-4l-1-8-2-13-1-8h12l-18-1a419%20419%200%2000-27%202l2%202c1%201%201%201%201-1v-2c1%200%202%201%202%203l-1%202%201%2015h2l1%202-1%201-1%202c0%202-1%203-4%203s-5%202-3%204l1%204v5l1%202%201-1h3c1-2%202-1%202%201v5c-1%202%209%202%2051%202s42-1%2042-2l-5-44v-4h37v10c1%208%201%209-1%2012-3%205-3%206%200%208%203%201%203%201%203-1l1-2c2%200%206%205%205%207l-1%203h-3l1-1%201-2c0-3-1-3-3%200l-2%203-1-3c-1-3-3-4-5-2l5%208%203%206c1%204%206%205%205%200-1-1%200-3%201-5%203-6%201-19-3-21-2-1-2-2-3-10v-10h8l1%2012%201%2014c0%205%202%2021%204%2022h4c5-2%2014-4%2015-3l5%202c6%202%206%201%206-25v-23H260m-175%202l2%202%201%202c0%202%206%2011%208%2011l1%201%204%201c4%201%206%204%206%209%200%202%203%204%204%202l1-13v-13l1-1c0-1-1-2-3-2l-3%202h-2c0-1-2-2-10-2l-10%201m213%2025v5l1%207v2l4-4%201-1%204-1%206-1%209-1-10-1c-9-1-10-1-11-3-3-3-4-4-4-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2e207228b485827c0624861944f2f6ad/ca0a1/techletter.app-screenshot-1569254610676.webp 223w", "/static/2e207228b485827c0624861944f2f6ad/75680/techletter.app-screenshot-1569254610676.webp 445w", "/static/2e207228b485827c0624861944f2f6ad/0ba47/techletter.app-screenshot-1569254610676.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2e207228b485827c0624861944f2f6ad/e92b6/techletter.app-screenshot-1569254610676.png 223w", "/static/2e207228b485827c0624861944f2f6ad/e66bf/techletter.app-screenshot-1569254610676.png 445w", "/static/2e207228b485827c0624861944f2f6ad/6af66/techletter.app-screenshot-1569254610676.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2e207228b485827c0624861944f2f6ad/6af66/techletter.app-screenshot-1569254610676.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      